import { Injectable } from '@angular/core';
import {HttpInterceptor2} from "./HttpInterceptor.service";
import {GlobalVariable} from "./global.vars";


@Injectable()
export class DeviceMsgService {
  private Http: HttpInterceptor2;
  private API_URL = GlobalVariable.API_URL;

  constructor (public httpInterceptor: HttpInterceptor2) {
    this.Http = httpInterceptor;
  }

  getDeviceMsgAgg(agg,limit?,page?){
    let l=10;
    let p= 1;
    if (page) p=page;
    if (limit) l=limit;

    return this.Http.post(this.API_URL+'/device_msg/aggregate',agg)
  }




}



// WEBPACK FOOTER //
// ./src/services/deviceMsg.service.ts